import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Footer.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Header/Header.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/pages/Home.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Portal/Portal.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/VoteTicker.tsx")